import React from "react"

const InfoCircleFill = ({ size = 16, color = "white", ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      {...rest}
    >
      <path
        // eslint-disable-next-line
        d="M8 11C8.17 11 8.3126 10.9424 8.4278 10.8272C8.5426 10.7124 8.6 10.57 8.6 10.4V7.985C8.6 7.815 8.5426 7.675 8.4278 7.565C8.3126 7.455 8.17 7.4 8 7.4C7.83 7.4 7.6876 7.4574 7.5728 7.5722C7.4576 7.6874 7.4 7.83 7.4 8V10.415C7.4 10.585 7.4576 10.725 7.5728 10.835C7.6876 10.945 7.83 11 8 11ZM8 6.2C8.17 6.2 8.3126 6.1424 8.4278 6.0272C8.5426 5.9124 8.6 5.77 8.6 5.6C8.6 5.43 8.5426 5.2874 8.4278 5.1722C8.3126 5.0574 8.17 5 8 5C7.83 5 7.6876 5.0574 7.5728 5.1722C7.4576 5.2874 7.4 5.43 7.4 5.6C7.4 5.77 7.4576 5.9124 7.5728 6.0272C7.6876 6.1424 7.83 6.2 8 6.2ZM8 14C7.17 14 6.39 13.8424 5.66 13.5272C4.93 13.2124 4.295 12.785 3.755 12.245C3.215 11.705 2.7876 11.07 2.4728 10.34C2.1576 9.61 2 8.83 2 8C2 7.17 2.1576 6.39 2.4728 5.66C2.7876 4.93 3.215 4.295 3.755 3.755C4.295 3.215 4.93 2.7874 5.66 2.4722C6.39 2.1574 7.17 2 8 2C8.83 2 9.61 2.1574 10.34 2.4722C11.07 2.7874 11.705 3.215 12.245 3.755C12.785 4.295 13.2124 4.93 13.5272 5.66C13.8424 6.39 14 7.17 14 8C14 8.83 13.8424 9.61 13.5272 10.34C13.2124 11.07 12.785 11.705 12.245 12.245C11.705 12.785 11.07 13.2124 10.34 13.5272C9.61 13.8424 8.83 14 8 14Z"
        fill={color}
      />
    </svg>
  )
}

export default InfoCircleFill
